import React from 'react'
import {Menu} from 'semantic-ui-react'
import {isString} from 'lodash/isString'
import {normalizeMenuItem, normalizeMenuItemPath} from './utils'

const _SectionMenu = ({isLeftNav = true, pathPrefix, navigate, location, menuItems = []}) => {
  const onMenuItemClick = (menuItem) => {
    const newPath = normalizeMenuItemPath(menuItem, {pathPrefix})
    if (menuItem.path && !location.pathname.endsWith(newPath)) {
      navigate(newPath)
    }
  }

  if(!menuItems.length) {
    return null
  }

  return (
    <>
      {
        isLeftNav && (
          <Menu.Menu>
            {
              menuItems.map((menuItem) => {
                const {name, content, active} = menuItem
                return (
                  <Menu.Item key={name}
                             name={name}
                             content={content}
                             active={active}
                             onClick={() => onMenuItemClick(menuItem)}
                  />
                )
              })
            }
          </Menu.Menu>
        )
      }
      {
        !isLeftNav && (
          <Menu pointing secondary>
            {
              menuItems.map((menuItem) => {
                const {name, content, active} = menuItem
                return (
                  <Menu.Item key={name}
                             name={name}
                             content={content}
                             active={active}
                             onClick={() => onMenuItemClick(menuItem)}
                  />
                )
              })
            }
          </Menu>
        )
      }
    </>
  )
}

const SectionMenu = (props) => {
  let {pathPrefix, menuItems = [], location} = props
  menuItems = menuItems.map(menuItem => {
    menuItem = normalizeMenuItem(menuItem)
    menuItem.active = location.pathname.endsWith(normalizeMenuItemPath(menuItem, {pathPrefix}))
    return menuItem
  })
  // if (menuItems.length && !menuItems.some(mi => mi.active)) {
  //   menuItems[0].active = true
  // }
  props = {...props, menuItems}
  return (<_SectionMenu {...props}/>)
}

export {_SectionMenu, SectionMenu}

export default SectionMenu